<template>
    <div>
        <v-layout row justify-end align-center>
            <v-btn
                color="secondary"
                v-if="torzsAdat || value"
                small
                class="button mr-5"
                @click="inkabbUjGepjarmu()"
            >
                Másik gépjármű
            </v-btn>

            <v-dialog v-model="dialog" persistent max-width="1034px">
                <template v-slot:activator="{ on }">

                    <v-btn
                        color="secondary"
                        v-on="on"
                        class="button"
                    >
                        <v-icon>{{ icons.mdiCar }}</v-icon>
                    </v-btn>

                </template>

                <v-card>

                    <v-card-title class="headline">
                        Gépjármű betöltése

                    </v-card-title>

                    <v-card-text>
                        <v-text-field
                            v-model="rendszam.value"
                            v-bnmask="'GGGGGGGGG'"
                            v-if="dialog"
                            autofocus
                            color="secondary"
                            label="Rendszám"
                            :error-messages="rendszam.error_msg"
                            :error="rendszam.error"
                            placeholder=" "
                            :outlined="cfg.props.outlined"
                            @keydown.enter="() => {
                                    if(!eurotaxSelect && !alternativeFull) {
                                        selectGepjarmu()
                                    }
                                }"
                        />
                        <v-progress-linear
                            v-if="loading"
                            indeterminate
                            color="secondary"
                        ></v-progress-linear>

                        <div
                            v-if="alternativeFull && (vanCasco || environment === 'gap')"
                            style="margin-top: 25px;"
                        >
                            <p>
                                <b>Kérjük válassza ki a járművet</b> az alábbi lehetőségek segítségével.
                            </p>
                            <v-layout row wrap>
                                <v-flex md6 xs12 class="pa-3">
                                    <v-btn
                                        color="secondary"
                                        style="width: 90%"
                                        @click="EurotaxAdatbazisbolBtnClicked()"
                                    >

                                        Eurotax adatbázisból

                                    </v-btn>
                                </v-flex>
                                <v-flex md6 xs12 class="pa-3">
                                    <v-btn
                                        color="secondary"
                                        style="width: 90%; margin-left: 0;"
                                        @click="EurotaxKodAlapjanBtnClick()"
                                    >

                                        Eurotax kód alapján

                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </div>

                        <EurotaxLoader
                            :rendszam="rendszam.value"
                            @input="eurotaxSelected()"
                            v-model="eurotaxcodeForLazyLoader"
                            :key="etaxdrop"
                            @no-car-found="noCarFound()"
                            @inkabb-uj-gepjarmu="inkabbUjGepjarmu()"
                            v-if="eurotaxSelect"
                            :skip-car-insurable-extras="environment !== 'cascokgfb'"
                        />

                    </v-card-text>

                    <v-card-actions>

                        <v-spacer/>

                        <v-btn class="button"
                               color="primaryButtonColor"
                               style="color: var(--v-primaryButtonTextColor-base);"
                               @click.native="megse()">
                            Mégse
                        </v-btn>

                        <v-btn
                            v-if="!eurotaxSelect && !alternativeFull"
                            color="secondary"
                            @click.native="selectGepjarmu()">
                            Betöltés
                        </v-btn>

                    </v-card-actions>

                </v-card>

            </v-dialog>
        </v-layout>
    </div>
</template>

<script>
import { mdiCar } from '@mdi/js';
import modozat from '../gfb/shared/mixins/modozat';
import gepjarmutorzsService from '../../services/GepjarmutorzsService';
import EurotaxLoader from '../EurotaxLoader/EurotaxLoader.vue';
import loadByEurotax from '../gfb/uzletkoto/mixins/loadByEurotax';

export default {
    components: {
        EurotaxLoader,
    },
    mixins: [
        modozat,
        loadByEurotax,
    ],
    data: () => ({
        torzsAdat: false,
        icons: {
            mdiCar,
        },
        eurotaxcodeForLazyLoader: null,
        eurotaxSelect: false,
        alternativeFull: false,
        dialog: false,
        loading: false,
        etaxdrop: 0,
        rendszam: {
            value: null,
            error: false,
            error_msg: null,
        },
    }),

    props: {
        path: {
            type: String,
            default: 'gepjarmu',
        },
        value: {
            type: String,
            default: null,
        },
        setCarData: {
            type: Function,
            required: true,
        },
        environment: {
            type: String,
            required: true,
        },
    },

    mounted() {
        this.rendszam.value = this.rendszamStore;
    },

    watch: {
        eurotaxcodeForLazyLoader() {
            this.$emit('input', this.eurotaxcodeForLazyLoader);
        },
        dialog(val) {
            this.eurotaxSelect = false;
            this.alternativeFull = false;
            this.rendszam.error = false;
            this.rendszam.error_msg = null;
            if (val) {
                this.$emit('dialog-state-change', this.dialog);
            }
        },
        value() {
            this.dialog = false;
        },
        rendszamValue() {
            this.eurotaxSelect = false;
            this.alternativeFull = false;
        },
        vanCasco() {
            if (!this.reloaded) {
                this.inkabbUjGepjarmu();
            }
        },
        vanGfb() {
            if (!this.reloaded) {
                this.inkabbUjGepjarmu();
            }
        },
        rendszamStore(val) {
            this.rendszam.value = val;
        },
    },

    computed: {
        reloaded() {
            return !!this.$store.getters.tarifaData.id && this.$store.getters.tarifaData.id !== 0;
        },
        rendszamValue() {
            return this.rendszam.value;
        },
        rendszamStore() {
            return this.$store.getters.gepjarmu.rendszam;
        },
    },

    methods: {
        EurotaxAdatbazisbolBtnClicked() {
            this.dialog = false;
            this.$emit('open-etax-select');
        },
        EurotaxKodAlapjanBtnClick() {
            this.dialog = false;
            this.$emit('eurotax-kod-alapjan-btn-click');
        },
        noCarFound() {
            this.rendszam.error = true;
            this.rendszam.error_msg = 'A CASCO tarifáláshoz a gépjárműtörzsben'
                + ' szereplő adatoknál pontosabb beazonosításra van szükség.';
            this.eurotaxSelect = false;
            this.alternativeFull = true;
        },
        eurotaxSelected() {
            this.resetSearchForm();
            this.torzsAdat = true;
            this.dialog = false;
        },
        resetSearchForm() {
            this.rendszam.value = null;
            this.rendszam.error = false;
            this.rendszam.error_msg = null;
            this.eurotaxSelect = false;
        },

        clearGepjarmuData() {
            this.resetSearchForm();
        },

        megse() {
            this.resetSearchForm();
            this.dialog = false;
        },

        inkabbUjGepjarmu() {
            this.dialog = false;
            this.torzsAdat = false;
            this.etaxdrop += 1;
            this.eurotaxSelect = false;
            this.eurotaxcodeForLazyLoader = null;
            this.alternativeFull = false;
            this.clearGepjarmuData();
            this.$emit('masik-gepjarmu');
        },

        selectGepjarmu() {
            this.rendszam.error = false;
            this.rendszam.error_msg = null;
            this.loading = true;
            gepjarmutorzsService.getGepjarmu(
                this.$store.getters.getBroker.ceg,
                this.rendszam.value,
            )
                .then(
                    (response) => {
                        this.loading = false;
                        if (
                            !(
                                response.data.length === 0
                            )
                        ) {
                            if (
                                (
                                    this.vanCasco
                                    || this.environment === 'gap'
                                ) && !response.data[0].eurotaxcode
                            ) {
                                this.eurotaxSelect = true;
                                this.torzsAdat = false;
                                this.rendszam.error = true;
                                this.rendszam.error_msg = 'A CASCO tarifáláshoz a gépjárműtörzsben '
                                    + 'szereplő adatoknál pontosabb beazonosításra van szükség.';
                            } else {
                                this.rendszam.error = false;
                                this.rendszam.error_msg = null;
                                this.dialog = false;
                                this.torzsAdat = true;
                            }
                            this.setCarData(response.data[0]);
                        } else {
                            this.rendszam.error = true;
                            this.rendszam.error_msg = 'Nem található autó a megadott renszámmal';
                            this.torzsAdat = false;
                            this.alternativeFull = true;
                        }
                    },
                );
        },
    },
};
</script>
<style scoped>
.snackbar {
    font-size: 20px;
}
</style>
